import { Link } from "react-router-dom";
import { Placeholder } from "@/components/Placeholder";

const FOOTER_NAV = [
  { to: "/services", label: "Services" },
  { to: "/our-standards", label: "Our Standards" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/request-a-nanny-match", label: "Request a Nanny Match" },
  { to: "/for-nannies", label: "For Nannies" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const LEGAL_NAV = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-service", label: "Terms of Service" },
];

export const Footer = () => (
  <footer className="mt-24 bg-[#0B0A08] text-[#F7F4ED]" data-testid="site-footer">
    <div className="container-page grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
      <div className="lg:col-span-1">
        <p className="font-serif text-2xl tracking-tight">Nanny Poppins</p>
        <p className="mt-1 text-[0.62rem] font-semibold uppercase tracking-[0.3em] text-[#C6A04A]">
          United Arab Emirates
        </p>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#F7F4ED]/65">
          A calm, considered nanny-matching service for families across the Emirates.
        </p>
      </div>

      <div>
        <h4 className="text-sm font-semibold uppercase tracking-wider text-[#C6A04A]">Explore</h4>
        <ul className="mt-4 space-y-2.5">
          {FOOTER_NAV.map((n) => (
            <li key={n.to}>
              <Link
                to={n.to}
                data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-[#F7F4ED]/70 transition-colors hover:text-[#C6A04A]"
              >
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-semibold uppercase tracking-wider text-[#C6A04A]">Legal</h4>
        <ul className="mt-4 space-y-2.5">
          {LEGAL_NAV.map((n) => (
            <li key={n.to}>
              <Link
                to={n.to}
                data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-[#F7F4ED]/70 transition-colors hover:text-[#C6A04A]"
              >
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-sm font-semibold uppercase tracking-wider text-[#C6A04A]">Contact</h4>
        <ul className="mt-4 space-y-3 text-sm text-[#F7F4ED]/70">
          <li className="flex flex-col gap-1">
            <span>Email</span>
            <Placeholder>Business email — coming soon</Placeholder>
          </li>
          <li className="flex flex-col gap-1">
            <span>Phone / WhatsApp</span>
            <Placeholder>Number — coming soon</Placeholder>
          </li>
          <li className="flex flex-col gap-1">
            <span>Office hours</span>
            <Placeholder>Hours — to be confirmed</Placeholder>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[#F7F4ED]/10">
      <div className="container-page flex flex-col gap-3 py-6 text-xs text-[#F7F4ED]/50 md:flex-row md:items-center md:justify-between">
        <p>
          © {new Date().getFullYear()} <Placeholder>Legal entity name — to be confirmed</Placeholder>. All rights reserved.
        </p>
        <p>
          Licence: <Placeholder>Licence details — to be confirmed</Placeholder>
        </p>
      </div>
    </div>
  </footer>
);
